import React from 'react';
import { useNavigate } from 'react-router-dom';

import './TermosDeUso.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import HeaderLogos from '../../components/HeaderLogos/HeaderLogos';
import Footer from '../../components/Footer/Footer';
import { TermOfUseText } from '../../components/TermOfUseText/TermOfUseText';

library.add(faArrowLeft);

function TermosDeUso() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundColor: '#F9F9F9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="content">
        <HeaderLogos />

        <div className="text">
          <h1 className="title">Termo de Uso</h1>
          <div className="contentTexts">
            <TermOfUseText />
          </div>
        </div>
        <button
          onClick={() => {
            navigate('/');
          }}
          className="buttonTextWithIconGoBackTermUse"
        >
          <FontAwesomeIcon
            icon="fa-solid fa-arrow-left"
            size="1x"
            color="#1351b4"
            style={{ marginRight: '10px' }}
          />
          Voltar
        </button>
      </div>
      <Footer />
    </div>
  );
}

export { TermosDeUso };
